export const MODEL_STATE_TAG_MAPPER = {
  live: { color: "green", name: "Live" },
  challenger: { color: "orange", name: "Challenger" },
  disabled: { color: "blue", name: "Idle" },
  "pending-action": { color: "yellow", name: "Pending Action" },
} as const

export const PROHIBITED_LABELS_KEYWORDS = ["__all_labels__"]

export const PROHIBITED_REASONS_KEYWORDS = ["__all_reasons__"]

export const PROHIBITED_WORKFLOWS_KEYWORDS = ["__all_workflows__"]

export const FEATURE_NESTING_SEPARATOR = ">>>"

export const FEATURE_COMPARISON_DELIMITER = "<-->"
